<template>
    <div>
        <el-dialog
            :title="dialogFormTitle"
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            width="1000px"
            :center="true"
            top="50px"
            :close-on-click-modal="false"
            :before-close="() => closeShopBackDialog('ShopBackEditForm')"
            v-loading.fullscreen.lock="login_loading"
        >
            <div>
                <el-form
                    :model="ShopBack"
                    ref="ShopBackEditForm"
                    label-width="100px"
                    size="small"
                >
                    <div v-if="show_type">
                        <el-descriptions
                            direction="vertical"
                            :column="2"
                            :labelStyle="{'width':'120px','text-align':'center'}"
                            :contentStyle="{'text-align': 'center','width':'50%'}"
                            border
                        >
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>背景墙图片</span>
                                </template>
                                <common-upload-component
                                    ref="upload"
                                    :limit=1
                                    :ffileList="ShopBack.picture"
                                ></common-upload-component>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>背景墙信息</span>
                                </template>
                                <el-descriptions
                                    class="margin-top"
                                    :column="1"
                                    :labelStyle="{'text-align': 'center','width':'120px'}"
                                    :contentStyle="{'text-align': 'center'}"
                                    border
                                >
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>状态</span>
                                        </template>
                                        <el-select
                                            v-model="ShopBack.state"
                                            filterable
                                            clearable
                                            placeholder="选择状态"
                                            class="state_c"
                                        >
                                            <el-option
                                                v-for="item in AllState"
                                                :key="item.name"
                                                :label="item.name"
                                                :value="item.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>名称</span>
                                        </template>
                                        <el-input v-model="ShopBack.name" placeholder="请填写背景墙名称"></el-input>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>代码</span>
                                        </template>
                                        <el-input v-model="ShopBack.code" placeholder="请填写背景墙代码"></el-input>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>类型</span>
                                        </template>
                                        <el-select
                                            v-model="ShopBack.type"
                                            filterable
                                            clearable
                                            placeholder="选择背景墙属性"
                                            class="type_c"
                                        >
                                            <el-option
                                                v-for="item in AllType"
                                                :key="item.name"
                                                :label="item.name"
                                                :value="item.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-descriptions-item>
                                </el-descriptions>
                            </el-descriptions-item>
                            <el-descriptions-item :span=2>
                                <template slot="label">
                                    <span>背景墙说明</span>
                                </template>
                                <common-editor-component
                                    ref="editor"
                                    :fcontent="ShopBack.note"
                                ></common-editor-component>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                    <div v-else>
                        <el-descriptions
                            direction="vertical"
                            :column="2"
                            :labelStyle="{'width':'120px','text-align':'center'}"
                            :contentStyle="{'text-align': 'center','width':'50%'}"
                            border
                        >
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>背景墙图片</span>
                                </template>
                                <img v-if="ShopBack.picture.length" :src="ShopBack.picture[0].url" height="200px" alt="">
                                <common-upload-component
                                    ref="upload"
                                    v-show="false"
                                    :disabled="true"
                                    :ffileList="ShopBack.picture"
                                ></common-upload-component>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>背景墙信息</span>
                                </template>
                                <el-descriptions
                                    class="margin-top"
                                    :column="1"
                                    :labelStyle="{'text-align': 'center','width':'120px'}"
                                    :contentStyle="{'text-align': 'center'}"
                                    border
                                >
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>状态</span>
                                        </template>
                                        <el-tag type="success" v-if="this.is_have_back">已拥有</el-tag>
                                        <el-tag type="danger" v-else>未拥有</el-tag>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>名称</span>
                                        </template>
                                        <span>{{ShopBack.name}}</span>
                                    </el-descriptions-item>
                                    <el-descriptions-item>
                                        <template slot="label">
                                            <span>类型</span>
                                        </template>
                                        <el-tag effect="plain" type="info" v-if="ShopBack.type === 1">普通</el-tag>
                                        <el-tag effect="plain" v-else-if="ShopBack.type === 2">限定</el-tag>
                                        <el-tag effect="plain" type="danger" v-else-if="ShopBack.type === 3">专属</el-tag>
                                    </el-descriptions-item>
                                </el-descriptions>
                            </el-descriptions-item>
                            <el-descriptions-item :span=2 :contentStyle="{'text-align':'left','white-space':'pre-line'}">
                                <template slot="label">
                                    <span>背景墙说明</span>
                                </template>
                                <div class="el-tiptap-editor__content" v-html="ShopBack.note"></div>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <div v-if="show_type===0">
                    <el-button
                        v-if="!this.is_have_back && this.UserItems['常规个人背景自选'] && (this.UserItems['常规个人背景自选'] > 0) && (this.ShopBack.type === 1)"
                        type="primary"
                        plain
                        round
                        @click="exchange"
                        >【常规个人背景自选】卡兑换（剩余{{ this.UserItems['常规个人背景自选'] }}张）</el-button
                    >
                    <el-button
                        v-if="$_has(edit_auth)"
                        type="primary"
                        plain
                        @click="$emit('show_edit')"
                        >修改</el-button
                    >
                    <el-button
                        v-if="$_has(del_auth)"
                        type="danger"
                        plain
                        @click="ShopBackDel('ShopBackEditForm')"
                        >删除</el-button
                    >
                    <el-button
                        plain
                        @click="closeShopBackDialog('ShopBackEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else-if="show_type===1">
                    <el-button
                        type="success"
                        plain
                        @click="submitInsert('ShopBackEditForm')"
                        >确定</el-button
                    >
                    <el-button
                        type="warning"
                        plain
                        @click="resetForm('ShopBackEditForm')"
                        >重置</el-button
                    >
                    <el-button
                        plain
                        @click="closeShopBackDialog('ShopBackEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else>
                    <el-button
                        type="success"
                        plain
                        @click="submitEdit('ShopBackEditForm')"
                        >确定修改</el-button
                    >
                    <el-button
                        plain
                        @click="$emit('cancel_edit')"
                        >取消操作</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ShopBackAddRequest,ShopBackDelRequest,ShopBackEditRequest } from '@/network/shop/ShopBack.js'
import { ExchangeBackRequest } from '@/network/user.js'
import CommonUploadComponent from '@/components/common/CommonUploadComponent'
import CommonEditorComponent from '@/components/common/CommonEditorComponent'

export default {
    name: 'ShopBackEditComponent',
    data() {
        return {
            login_loading: false,
            ShopBack: {
                state: '',
                name: '',
                picture: [],
                code: '',
                type: '',
                note: ''
            }
        }
    },
    computed: {
        dialogFormTitle() {
            if(this.show_type === 0) {
                return '背景墙详情'
            } else if (this.show_type === 1) {
                return '添加背景墙'
            } else {
                return '修改背景墙'
            }
        },
    },
    methods: {
        closeShopBackDialog(formName) {
            this.resetForm(formName)
            this.$emit('exitShopBackDialog')
        },
        submitInsert(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.ShopBackInsert(formName)
            })
        },
        ShopBackInsert(formName) {
            this.login_loading = true
            this.ShopBack.picture = this.$refs.upload.fileList
            this.ShopBack.note = this.$refs.editor.content
            ShopBackAddRequest(this.ShopBack)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('添加成功!')
                        this.$emit('exitShopBackDialog')
                        this.$emit('search')
                        this.$emit('details_row',s.result.id*1)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        resetForm(formName) {
            this.$refs.upload.hideUpload = false
            this.$refs.upload.fileList = []
            this.ShopBack = {
                state: '',
                name: '',
                picture: [],
                code: '',
                note: ''
            }
        },
        submitEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.ShopBackEdit(formName)
            })
        },
        ShopBackEdit(formName) {
            this.login_loading = true
            this.ShopBack.id = this.id
            this.ShopBack.picture = this.$refs.upload.fileList
            this.ShopBack.note = this.$refs.editor.content
            ShopBackEditRequest(this.ShopBack)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('修改成功!')
                        this.$emit('exitShopBackDialog')
                        this.$emit('search')
                        this.$emit('details_row',this.ShopBack.id)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        ShopBackDel(formName) {
            this.$confirm(
                '是否确定删除？（一经删除，将无法再进行恢复，请谨慎操作！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    ShopBackDelRequest(this.id)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('删除成功!')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.$message.error(err)
                        })
                        .finally(() => this.closeShopBackDialog(formName))
                })
                .catch((err) => {})
        },
        exchange() {
            this.$confirm(
                '是否确定兑换？（将扣除一张对应兑换卡，且不支持7天无理由退货！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    this.login_loading = true
                    ExchangeBackRequest({back_id: this.id})
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('兑换成功！')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.loading = false
                            this.$message.error(err)
                        })
                        .finally(() => {
                            this.$emit('RefreshItems')
                            this.$emit('details_row',this.ShopBack.id)
                        })
                        
                        this.login_loading = false
                })
                .catch((err) => {})
        }
    },
    filters: {},
    props: {
        dialogFormVisible: Boolean,
        id: {
            type: Number,
            default() {
                return 0
            },
        },
        shop_back_details_data: {
            type: Object,
            default() {
                return {}
            },
        },
        show_type: {
            type:Number,
            default() {
                return 0
            },
        },
        AllState: {
            type: Array,
            default() {
                return []
            }
        },
        AllType: {
            type: Array,
            default() {
                return []
            }
        },
        UserItems: {
            type: Object|Array,
            default() {
                return {}
            }
        },
        is_have_back: {
            type: Boolean,
            default() {
                return true
            }
        },
        edit_auth: String,
        del_auth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {
        CommonUploadComponent,
        CommonEditorComponent
    },
    watch: {
        shop_back_details_data(newVal) {
            this.ShopBack = newVal
        },
    },
}
</script>

<style lang='less' scoped>
.state_c,.type_c {
    width: 100%
}
</style>